import { Badge, NativeSelect } from '@mantine/core'
import { IconEdit } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

import styles from './CartLineItemInterval.module.scss'

import type { ComboboxData } from '@mantine/core'

interface CartLineItemIntervalProps {
  selectElements: ComboboxData
  sellingPlanInterval: number
  defaultSellingPlanInterval?: number
  setSelectedPlanAndInterval: (value: string) => void
  isEditingInterval: boolean
  setIsEditingInterval: (maybe: boolean) => void
  inMinicart?: boolean
}

export const CartLineItemInterval = ({
  selectElements,
  sellingPlanInterval,
  defaultSellingPlanInterval,
  setSelectedPlanAndInterval,
  isEditingInterval,
  setIsEditingInterval,
  inMinicart = false,
}: CartLineItemIntervalProps) => {
  const { t } = useTranslation()

  const intervalText = `${t('pdp.subscription.every')} ${sellingPlanInterval} ${t('pdp.subscription.weeks')}`

  if (!(defaultSellingPlanInterval && selectElements.length)) {
    return null
  }

  if (inMinicart) {
    return <div className={styles.interval}>{intervalText}</div>
  }

  if (isEditingInterval) {
    return (
      <div className={styles.dropdown}>
        <NativeSelect
          size="sm"
          data={selectElements}
          value={sellingPlanInterval.toString()}
          onChange={(event) => setSelectedPlanAndInterval(event.target.value)}
        />
      </div>
    )
  }

  return (
    <Badge onClick={() => setIsEditingInterval(true)} className={styles.button} rightSection={<IconEdit size={18} />}>
      {intervalText}
    </Badge>
  )
}
